/*jshint scripturl:true*/

import register from '../register.js';

register( 'zendesk-chat', function() {

  let scriptURL = 'https://assets.zendesk.com/embeddable_framework/main.js';
  let starryURL = 'starry.zendesk.com';

  window.zEmbed || function( e, t ) {
    let n;
    let o;
    let d;
    let i;
    let s;
    let a;
    let r = document.createElement('iframe');

    window.zEmbed = function() {
      a.push( arguments );
    };

    window.zE = window.zE || window.zEmbed;

    r.src = 'javascript:false';
    r.title = '';
    r.role = 'presentation';
    ( r.frameElement || r ).style.cssText = 'display: none';

    d = document.getElementsByTagName('script');
    d = d[ d.length - 1 ];
    d.parentNode.insertBefore( r, d );

    i = r.contentWindow;

    s = i.document;

    try {
      o = s;
    } catch ( e ) {
      n = document.domain;
      r.src = 'javascript:let d=document.open();d.domain="' + n + '";void(0);';
      o = s;
    }

    o.open()._l = function() {
      let o = this.createElement('script');
      n && ( this.domain = n );
      o.id = 'js-iframe-async';
      o.src = e;
      this.t = +( new Date() );
      this.zendeskHost = t;
      this.zEQueue = a;
      this.body.appendChild( o );
    };

    o.write('<body onload="document._l();">');
    o.close();
  }( scriptURL, starryURL );

});

export default undefined;
